<template>
  <el-dialog title="添加学生" :visible="dialogShow" @open="dialogOpen" width="800px" @close="dialogClose"
    :close-on-click-modal="false">
    <!-- 选择上传学生的方式 -->
    <div class="addstudent-choose-container" v-show="isChooseContainerShow">
      <div class="addstudent-student-single choose-card-container" @click="chooseAddStudentModeByForm">
        <div class="addstudent-image-container">
          <img src="~@/assets/image/common/single.png" class="type_image" />
        </div>
        <div class="addstudent_type_text">添加单个学生</div>
      </div>
      <div class="addstudent-student-upload choose-card-container" @click="chooseAddStudentModeByUpload">
        <div class="addstudent-image-container">
          <img src="~@/assets/image/common/upload.png" class="type_image" />
        </div>
        <div class="addstudent_type_text">添加多个学生</div>
      </div>
    </div>
    <div v-show="!isChooseContainerShow">
      <!-- 表单 -->
      <addStudentForm v-show="addStudentMode == 'form'" ref="addStudentForm" @formSubmit="formSubmit"
        :classProps="classProps" :classSelect="classSelect" :studentTypeList="studentTypeList"
        :gradeSelectList="gradeSelectList" />
      <!-- 上传文件 -->
      <addStudentUpload v-show="addStudentMode == 'upload'" ref="addStudentUpload" @uploadSuccess="uploadSuccess"
        :gradeSelectList="gradeSelectList" :studentTypeList="studentTypeList" />
    </div>
  </el-dialog>
</template>

<script>
import addStudentUpload from "../studentifno-addstudent-upload/studentifno-addstudent-upload.vue";
import addStudentForm from "../studentifno-addstudent-form/studentifno-addstudent-form.vue";

export default {
  components: {
    addStudentUpload,
    addStudentForm,
  },
  data() {
    return {
      dialogShow: false,
      isChooseContainerShow: true, // 为true时显示两种上传方式供选择，为false根据addStudentMode的值显示两种上传方式的一种
      addStudentMode: "",
      classInfoData: "",
    };
  },
  watch: {
    isAddStudentDialogShow() {
      this.dialogShow = this.isAddStudentDialogShow;
    },
    classData: {
      handler(newVal, oldVal) {
        // console.log("当前选中的班级==>", newVal);
        this.classInfoData = newVal;
      },
      deep: true,
    },
  },
  mounted() {
    //  console.log("当前选中的班级==>",this.classData);
  },
  inject: ["refresh"],
  props: ["isAddStudentDialogShow", "classData", "classSelect", "classProps", "studentTypeList", "gradeSelectList"],
  // props: {
  //   isAddStudentDialogShow: {
  //     type: Boolean,
  //     default: false,
  //   },
  //   classData: {
  //     type: Array,
  //     default: () => [],
  //   },
  // },
  methods: {
    // 打开弹出窗口
    dialogOpen() {
      // 显示两种
      this.isChooseContainerShow = true;
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$refs.addStudentForm.reset();
      this.$refs.addStudentUpload.reset();
      this.$emit("update:isAddStudentDialogShow", false);
    },
    chooseAddStudentModeByForm() {
      this.isChooseContainerShow = false;
      this.addStudentMode = "form";
    },
    chooseAddStudentModeByUpload() {
      this.isChooseContainerShow = false;
      this.addStudentMode = "upload";
    },
    // 添加单个学生提交
    formSubmit(data) {
      // console.log(this.class);
      let {
        studentNumber,
        studentName,
        address,
        duty,
        politicsStatus,
        classNameVal,
        status,
        sex,
        nation,
        birthday,
        allergen,
        medicalHistory,
        nativePlace,
        primarySchool,
        studentPhone,
        patriarchPhone,
        gradeId,
        classId,
        gradeName,
        className,
        idCard
      } = data;
      let { schoolId, schoolName } = this.user;
      // let { gradeId, gradeName } = this.classInfoData[0];
      // let { classId, className } = this.classInfoData[1];
      // let { gradeId, gradeName } = classNameVal[0];
      // let { classId, className } = classNameVal[1];
      let list = [
        {
          createBy: this.user.id,
          studentNumber,
          studentName,
          address,
          schoolId,
          schoolName,
          idCard,
          // gradeId,
          // gradeName,
          // classId,
          // className,
          duty,
          status,
          politicsStatus,
          sex,
          nation,
          birthday,
          allergen,
          medicalHistory,
          nativePlace,
          primarySchool,
          studentPhone,
          patriarchPhone,
          gradeId,
          classId,
          gradeName,
          className,
        },
      ];
      this.post(this.$url.insertStudentPC, list)
        .then((res) => {
          // console.log(res);
          if (res.code == 200) {
            this.$message.success("添加成功");
            // 刷新列表
            this.refresh();
            // 关闭弹出框
            this.dialogClose();
            // if (res.data.length) {
            //   this.$message.error("该学生学号已存在，请勿重复添加");
            // } else {
            //   this.$message.success("添加成功");
            //   // 刷新列表
            //   this.refresh();
            //   // 关闭弹出框
            //   this.dialogClose();
            // }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          // this.$message.error("添加失败，请稍后再试");
        });
    },
    // 上传excel成功，关闭弹出框，刷新列表
    uploadSuccess(option) {
      // console.log(option);
      // 刷新列表
      this.refresh();
      // 关闭弹出框
      this.dialogClose();
      if (option.length != 0) {
        this.$emit("uploadFailList", option);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "./studentinfo-addstudent-dialog.scss";
</style>
